import { render, staticRenderFns } from "./VoteScoreDetails.vue?vue&type=template&id=36da5f04"
import script from "./VoteScoreDetails.vue?vue&type=script&lang=js"
export * from "./VoteScoreDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports